<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="userId" label="客户名称">
              <el-select filterable clearable v-model="formData.userId" placeholder="请选择客户名称" style="width:95%">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositType" label="类型">
              <el-select v-model="formData.depositType" placeholder="请选择类型">
                <el-option label="贷款" value="1" />
                <el-option label="还款" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositChange" label="金额">
              <el-input v-model="formData.depositChange" placeholder="请输入金额" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { validNumber3 } from '@/utils/validator'
export default {
  name: 'FinanceLoanAdd',
  data() {
    return {
      userList: [],
      formData: {
        loanId: '',
        userId: '',
        depositType: '',
        depositChange: null,
        fileList: [] // 贷款、还款合同或付款凭证附件
      },
      rules: {
        userId: [
          { required: true, message: '请选择客户名称', trigger: 'change' }
        ],
        depositType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        depositChange: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ]
      }
    }
  },
  computed: {
    loanId() {
      return this.$route.query.loanId
    }
  },
  created() {
    this.loadUserList()
    if (this.loanId) {
      this.loadDetails()
    }
  },
  methods: {
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '3'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.financeLoan.selectYxFinanceLoanByLoanId, {
        params: { loanId: this.loanId }
      }).then(res => {
        res.fileList = res.fileList || []
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.financeLoan.insertYxFinanceLoan
        if (this.loanId) {
          url = this.$apis.financeLoan.updateYxFinanceLoan
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-input-number {
  width: 95%;
}
</style>
